<template>
    <div>
        <div align="center" id="detail" style="display: block;">
            <table :class="tableClass">
                <caption v-html="this.$t('Calculette.result.resultatPrelevement', {
                    bareme: this.resultat.isBaremeAjuste ? '' : this.resultat.codeBaremePrelevement,
                    periodeFiscale: this.resultat.annee,
                    url: 'https://www.ge.ch/document/baremes-' + this.resultat.annee + '-perception-impot-source',
                    })"></caption>
                <thead class="hidden">
                    <tr>
                        <th scope="col">{{this.$t('general.resultat')}}</th>
                        <th scope="col">{{this.$t('general.valeur')}}</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-if="resultat.isBaremeAjuste">
                    <td :class='colLeft'><b>{{ $t("Calculette.result.revenuContribuable") }}</b></td>
                    <td :class='colRight'><b>{{formatCurrency(resultat.revenuContribuable)}}</b></td>
                </tr>
                <tr v-if="!resultat.isBaremeAjuste">
                    <td :class='colLeft'>{{ $t("Calculette.result.tauxPrelevementCont") }}</td>
                    <td :class='colRight'>{{resultat.tauxContribuable}}%</td>
                </tr>
                <tr v-if="resultat.isBaremeAjuste">
                    <td  :class='colLeft'>{{ $t("Calculette.result.tauxPrelevementCont") }} (Barème ajusté {{resultat.baremeAjuste}})</td>
                    <td :class='colRight'>{{resultat.tauxContribuable}}%</td>
                </tr>
                <tr>
                    <td :class='colLeft'>{{ $t("Calculette.result.montantPrelevementCont") }}</td>
                    <td :class='colRight'>{{formatCurrency(resultat.montantImpotContribuable)}}</td>
                </tr>
                <tr v-if="resultat.isBaremeAjuste">
                    <td :class='colLeft'><b>{{ $t("Calculette.result.revenuConjoint") }}</b></td>
                    <td :class='colRight'><b>{{formatCurrency(resultat.revenuConjoint)}}</b></td>
                </tr>
                <tr v-if="resultat.isBaremeAjuste">
                    <td v-if="!resultat.isTaux" :class='colLeft'>{{ $t("Calculette.result.tauxPrelevementConj") }} (Barème {{resultat.bareme}})</td>
                    <td v-else :class='colLeft'>{{ $t("Calculette.result.tauxPrelevementConj") }} (non imposé à Genève)</td>
                    <td :class='colRight' v-if="!resultat.isTaux">{{resultat.tauxConjoint}}%</td>
                    <td :class='colRight' v-else></td>
                </tr>
                <tr v-else>
                    <td :class='colLeft'>{{ $t("Calculette.result.tauxPrelevementConj") }}</td>
                    <td :class='colRight' v-if="!resultat.isTaux">{{resultat.tauxConjoint}}%</td>
                    <td :class='colRight' v-else></td>
                </tr>
                <tr>
                    <td :class='colLeft'>{{ $t("Calculette.result.montantPrelevementConj") }}</td>
                    <td :class='colRight' v-if="!resultat.isTaux">{{formatCurrency(resultat.montantImpotConjoint)}}</td>
                    <td :class='colRight' v-else></td>
                </tr>
                <tr>
                    <td :class='colLeft'><b>{{ $t("Calculette.result.totalPrelevementCouple") }}</b></td>
                    <td :class='colRight'><b>{{formatCurrency(resultat.montantImpotCouple)}}</b></td>
                </tr>
                </tbody>
            </table>
            <br>
        </div>
    </div>
</template>

<script>
import CurrencyUtils from '@/utils/CurrencyUtils';

export default {
  name: 'section-resultat-prelevement',
  props: ['resultat', 'colLeft', 'colRight', 'tableClass'],
  mixins: [CurrencyUtils],
};
</script>

<style scoped>

</style>
